import { render, staticRenderFns } from "./outsource-detail.vue?vue&type=template&id=071d0d08"
import script from "./outsource-detail.vue?vue&type=script&lang=ts"
export * from "./outsource-detail.vue?vue&type=script&lang=ts"
import style0 from "./outsource-detail.vue?vue&type=style&index=0&id=071d0d08&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports